import { FaArrowUpRightFromSquare, FaLock } from "react-icons/fa6";
import { useExperience } from "./hooks/useExperience";
import { getColorForName } from "./utils";
import { useLocale } from "./i18n/LocaleContext";

export function ProjectsDisplayer() {
  const { t } = useLocale();
  const experienceData = useExperience();

  return (
    <section className="relative w-full pt-2 pb-16">
      <div className="max-w-5xl mx-auto px-6 md:px-16">
        <div className="flex flex-col items-center mb-8">
          <h2 className="text-sm font-semibold tracking-[0.2em] uppercase text-zinc-500 dark:text-zinc-400">
            {t("sections.sideProjects")}
          </h2>
          <span className="mt-2 block h-px w-16 bg-gradient-to-r from-transparent via-zinc-400 dark:via-zinc-600 to-transparent" />
          <p className="mt-3 text-xs text-zinc-500 dark:text-zinc-400 max-w-md text-center">
            {t("sections.sideProjectsSub")}
          </p>
        </div>

        <div className="columns-1 sm:columns-2 lg:columns-3 gap-4">
          {experienceData.sideProjects.map((project, index) => (
            <div key={index} className="inline-block w-full mb-4 break-inside-avoid">
              <CardFolio
                name={project.name}
                link={project.link}
                description={project.description}
                stack={project.stack}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function CardFolio({ name, link, description, stack }) {
  const titleColor = getColorForName(name);
  const isPrivate = link === "private" || link === "#";
  const stackChips = stack.split(" - ").map((s) => s.trim()).filter(Boolean);

  const cardInner = (
    <div className="group relative flex flex-col gap-3 p-4 rounded-2xl bg-white/60 dark:bg-zinc-900/60 backdrop-blur-sm border border-zinc-200/70 dark:border-zinc-700/60 hover:border-zinc-300 dark:hover:border-zinc-600 hover:bg-white/85 dark:hover:bg-zinc-800/70 transition-all duration-200 hover:-translate-y-0.5 hover:shadow-xl hover:shadow-zinc-900/5 dark:hover:shadow-black/30">
      <div className="flex items-start justify-between gap-2">
        <p
          className="text-sm font-bold leading-tight"
          style={{ color: titleColor }}
        >
          {name}
        </p>
        {isPrivate ? (
          <FaLock className="w-3 h-3 text-zinc-400 dark:text-zinc-500 mt-1 shrink-0" />
        ) : (
          <FaArrowUpRightFromSquare className="w-3 h-3 text-zinc-400 dark:text-zinc-500 group-hover:text-zinc-700 dark:group-hover:text-zinc-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all mt-1 shrink-0" />
        )}
      </div>

      <p className="text-xs text-zinc-600 dark:text-zinc-400 leading-relaxed">{description}</p>

      <div className="flex flex-wrap gap-1.5 mt-1">
        {stackChips.map((tech) => (
          <span
            key={tech}
            className="inline-block text-[10px] px-2 py-0.5 rounded-full bg-zinc-100/80 dark:bg-zinc-800/80 text-zinc-600 dark:text-zinc-300 border border-zinc-200/60 dark:border-zinc-700/60"
          >
            {tech}
          </span>
        ))}
      </div>
    </div>
  );

  if (isPrivate) {
    return <div className="block">{cardInner}</div>;
  }

  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className="block"
    >
      {cardInner}
    </a>
  );
}
